import React, { useContext } from 'react'
import Navbar from './Navbar'
import { Outlet } from 'react-router-dom'
import { ThemeContext } from './themecontext/ThemeContext'

export default function App() {
  let { theme } = useContext(ThemeContext)
  return (
    <>
      <div className={theme === "dark" ? "bg-dark text-light min-vh-100" : "bg-light text-dark min-vh-100"}>
        <Navbar />
        <div className="container">
          <Outlet />
        </div>
      </div>
    </>
  )
}